import { Injectable, TemplateRef, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
    private readonly snackBar = inject(MatSnackBar);

    public showError(message: string, duration: number = 3000) {
        const config = new MatSnackBarConfig();
        config.duration = duration;
        config.panelClass = ['error'];
        this.snackBar.open(message, null, config);
    }

    public showSuccess(message: string, duration: number = 3000) {
        const config = new MatSnackBarConfig();
        config.duration = duration;
        config.panelClass = ['success'];
        this.snackBar.open(message, null, config);
    }

    public showConfirm(message: string, action: string = 'Potvrdit'): MatSnackBarRef<any> {
        const config = new MatSnackBarConfig();
        config.horizontalPosition = 'end';
        config.verticalPosition = 'top';
        config.panelClass = ['warning'];
        return this.snackBar.open(message, action, config);
    }

    public showErrorWithConfirmation(template: TemplateRef<any>): MatSnackBarRef<any> {
        const config = new MatSnackBarConfig();
        config.panelClass = 'error';
        return this.snackBar.openFromTemplate(template, config);
    }

    public showInfo(message: string, action: string = 'Rozumím'): MatSnackBarRef<any> {
        const config = new MatSnackBarConfig();
        config.duration = 10000;
        config.horizontalPosition = 'center';
        config.verticalPosition = 'top';
        config.panelClass = ['info'];
        return this.snackBar.open(message, action, config);
    }
}
